export default {
  listTitleTable: {
    COM_GROUP_CODE: 'TICKER',
    MATCH_PRICE: 'PRICE',
    PERCENT_PRICE_CHANGE: '1 DAY',
    PERCENT_PRICE_CHANGE_1WEEK: '1 WEEK',
    PERCENT_PRICE_CHANGE_1MONTH: '1 MONTH',
    PERCENT_PRICE_CHANGE_3MONTH: '3 MONTHS',
    PERCENT_PRICE_CHANGE_6MONTH: '6 MONTHS',
    PERCENT_PRICE_CHANGE_9MONTH: '9 MONTHS',
    PERCENT_PRICE_CHANGE_1YEAR: '1 YEAR',
    PERCENT_PRICE_CHANGE_YTD: 'YTD',
  },
}
